
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { ProjectSecretService } from '../../../../../../../shared/services/project-secret.service';

@Component({
  selector: 'app-secret-add-modal',
  imports: [
    FormsModule,
    InputText,
    ButtonModule
],
  templateUrl: './secret-add-modal.component.html',
  styleUrl: './secret-add-modal.component.scss'
})
export class SecretAddModalComponent {


  protected name: string = '';
  protected description: string = '';
  protected secret: string = '';

  constructor(
    private bsModalRef: BsModalRef,
    protected secretService: ProjectSecretService) {
  }

  protected cancel() {
    this.name = this.description = '';
    this.bsModalRef.hide();
  }

  protected async add() {
    await this.secretService.createSecret(this.name.trim(), this.description.trim(), this.secret.trim());
    this.cancel();
  }

  protected checkInput(): boolean {
    if (this.name.trim() === '' || this.secretService.projectSecrets.find(s => s.name == this.name.trim()) != null) return true;
    return false;
  }

}
